// extracted by mini-css-extract-plugin
module.exports = {"FocusRing":"FocusRing_FocusRing__13NAD","rounded":"FocusRing_rounded__wmV59"};